// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import axios from "axios"

// ** Constants
import { API_BUSINESSLINES_URL } from "../constants"

export const getListBusinessLines = createAsyncThunk(
    "businessLines/getListBusinessLines",
    async ({
        page = 1,
        limit = 20,
        search,
        status,
        noPaginate
    } = {}) => {

        let queryParams = `page=${page}&limit=${limit}`
        if (search) {
            queryParams += `&search=${search}`
        }
        if (status) {
            queryParams += `&status=${status}`
        }
        if (noPaginate) {
            queryParams += `&noPaginate=true`
        }
        const response = await axios.get(`${API_BUSINESSLINES_URL}?${queryParams}`)
        return response.data
    }
)

export const getListBusinessLinesAsOptions = createAsyncThunk(
    "businessLines/getListBusinessLinesAsOptions",
    async ({
        page = 1,
        limit = 20,
        search,
        status,
        noPaginate
    } = {}) => {

        let queryParams = `page=${page}&limit=${limit}`
        if (search) {
            queryParams += `&search=${search}`
        }
        if (status) {
            queryParams += `&status=${status}`
        }
        if (noPaginate) {
            queryParams += `&noPaginate=true`
        }
        const response = await axios.get(`${API_BUSINESSLINES_URL}?${queryParams}`)
        return response.data
    }
)

export const storeBusinessLine = createAsyncThunk(
    "businessLines/storeBusinessLine",
    async (data, { dispatch, getState }) => {
        const response = await axios.post(
            `${API_BUSINESSLINES_URL}`,
            data
        )
        console.log(`RESPONSE DATA`, response)
        return response.data
    }
)

export const updateBusinessLine = createAsyncThunk(
    "businessLines/updateBusinessLine",
    async (data, { dispatch, getState }) => {
        const response = await axios.put(
            `${API_BUSINESSLINES_URL}/${data._id}`,
            data
        )
        return response.data
    }
)

export const removeBusinessLine = createAsyncThunk(
    "businessLines/removeBusinessLine",
    async (id, { dispatch, getState }) => {
        const response = await axios.delete(
            `${API_BUSINESSLINES_URL}/${id}`
        )
        return response.data
    }
)

export const businessLinesSlice = createSlice({
    name: "businessLines",
    initialState: {
        list: [],
        totalPages: 1,
        loading: true,
        hasNextPage: false,
        pagingCounter: 0,
        totalDocs: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getListBusinessLines.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getListBusinessLines.fulfilled, (state, action) => {
                state.list = action.payload.docs
                state.totalPages = action.payload.totalPages
                state.hasNextPage = action.payload.hasNextPage
                state.pagingCounter = action.payload.pagingCounter
                state.totalDocs = action.payload.totalDocs
                state.loading = false
            })
    }
})

export default businessLinesSlice.reducer
